var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 123,
    viewBox: "0 0 122 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1301_17734)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53.2043,
    r: 25,
    fill: "#232ED1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7946 67.6136H57.2958V58.0248H66.0266V53.9158H57.017V49.4327C57.017 49.4327 57.0435 48.2465 58.4749 48.2729H67.4084V44.2634H55.3184V47.5582H51.922V53.6538H54.2415V56.3721H51.7978L51.7946 67.6136ZM45.5152 55.3991V53.9561H43.6596V55.8013H45.0587L46.6043 57.314V59.7857H49.5999V56.8072H46.9541L45.5152 55.3991ZM40.1804 42.3351V41.1814H38.5898V42.7629H39.7501L41.4404 44.4438V47.0037H44.0148L45.6645 48.644V51.5036H49.0046V48.1824H46.0609L44.4095 46.5403V44.0513H41.9064L40.1804 42.3351ZM49.5999 41.504V38.795H46.6043V41.9318H49.1696L50.8376 43.5904C50.8403 43.5931 50.843 43.5957 50.8457 43.5982V44.515H52.3568V43.0125H51.117L49.5999 41.504Z",
    fill: "#FBFEF9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1301_17734",
    x: 0,
    y: 0.204346,
    width: 122,
    height: 122,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.219608 0 0 0 0 0.533333 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1301_17734"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1301_17734",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.34a657add43bd8e883b24a9274b33118.svg";
export { ForwardRef as ReactComponent };